import { MrbBaseRouteStore } from "mrb/core";
import {
    StationService,
    StationFileStreamService,
    MediaVaultStreamService,
    LocationService,
    LanguageService,
    GenreLookupService,
} from "common/services";
import moment from "moment";

class StationEditRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(StationService);
        this.stationFileStreamService = rootStore.createApplicationService(StationFileStreamService);
        this.mediaVaultStreamService = new MediaVaultStreamService(
            this.rootStore.apiClient,
            this.rootStore.application.baasic
        );
        this.locationService = this.rootStore.createApplicationService(LocationService);
        this.languageService = this.rootStore.createApplicationService(LanguageService);
        this.genreLookupService = this.rootStore.createApplicationService(GenreLookupService);
    }

    async getStation(id) {
        const response = await this.service.get(id, {
            embed: "location,language,genres,stationPromo",
        });
        return response.data;
    }

    async createStation(data) {
        const response = await this.service.create(data);
        return response.data;
    }

    async updateStation(data) {
        const response = await this.service.update(data);
        return response.data;
    }

    getStationCoverImageUrl(coverImageId) {
        return this.stationFileStreamService.routeService.get(coverImageId);
    }

    async findGenres(searchPhrase) {
        const response = await this.genreLookupService.find(searchPhrase);
        return response.data;
    }

    async findLocations(searchPhrase) {
        const response = await this.locationService.find(searchPhrase);
        return response.data;
    }

    async createLocation(resource) {
        const response = await this.locationService.create(resource);
        return response.data;
    }

    async createLanguage(resource) {
        const response = await this.languageService.create(resource);
        return response.data;
    }

    async createGenre(resource) {
        const response = await this.genreLookupService.create(resource);
        return response.data;
    }

    async findLanguages(searchPhrase) {
        const response = await this.languageService.find(searchPhrase);
        return response.data;
    }

    async uploadImageFile(file) {
        const now = moment();
        const [name, extension] = file.name.split(".");
        const path = `${name}_${now.year()}-${now.month()}-${now.date()}-${now.hour()}-${now.minute()}-${now.second()}.${extension}`;
        const response = await this.mediaVaultStreamService.create(
            {
                path: path,
                fileName: file.name,
            },
            file
        );
        return response.data;
    }

    getMediaVaultFileUrl(id) {
        return this.mediaVaultStreamService.mediaVaultModule.streams.routeDefinition.get(id);
    }
}

export default StationEditRouteStore;
